import { configureStore } from "@reduxjs/toolkit";
import SetPortWorklocations from "./SetPortWorklocations";
import SetUserCredentials from "./SetUserCredentials";
import SetUserLanguage from "./SetUserLanguage";
import SetApplicationTitle from "./SetApplicationTitle";

export const store = configureStore({
  reducer: {
    userCredentials: SetUserCredentials,
    userLocale: SetUserLanguage,
    portWorklocations: SetPortWorklocations,
    applicationTitle: SetApplicationTitle,
  },

  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({
      serializableCheck: false,
    }),
  ],
});
